import React, { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { AddVendorCitySlice } from "../../../../redux/features/VendorCityManagementSlice";
import ButtonSpinner from "../../../../common/Loader/ButtonSpinner";

const CreateVendorCity = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const CityRef = useRef(null);
  const { loading } = useSelector((state) => state.VendorCityManagement);

  const [dataForSend, setDataForSend] = useState({
    cityName: "",
    state: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setDataForSend((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = () => {
    if (!dataForSend.cityName?.trim()?.length || !dataForSend.state?.trim()?.length) {
      toast.error("Please fill the details!");
      return;
    }

    dispatch(AddVendorCitySlice(dataForSend)).then((res) => {
      if (res?.payload?.data) {
        CityRef?.current?.click();
      }
    });
  };

  return (
    <div className="ModalBox">
      <div id="CreateVendorCity" className="modal fade" aria-hidden="true" data-backdrop="static">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className="Category">
                <a
                  onClick={() => navigate(-1)}
                  href="javascript:void(0);"
                  className="CloseModal"
                  data-dismiss="modal"
                  ref={CityRef}
                >
                  ×
                </a>
                <h3>Create Vendor City</h3>
                <div className="form-group">
                  <label>City Name</label>
                  <input
                    type="text"
                    name="cityName"
                    className="form-control"
                    placeholder="Enter City Name"
                    value={dataForSend.cityName}
                    onChange={handleChange}
                  />
                </div>
                <div className="form-group">
                  <label>State</label>
                  <input
                    type="text"
                    name="state"
                    className="form-control"
                    placeholder="Enter State"
                    value={dataForSend.state}
                    onChange={handleChange}
                  />
                </div>
                <button disabled={loading} onClick={handleSubmit} className="Button">
                  {loading ? <ButtonSpinner /> : "Add"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateVendorCity;
